/** Shared browser cooldown: Supabase outages must not fan out into retries from
 * auth refresh, account sync, world sync and every open tab at once. */
export function createSupabaseFetch(fetcher: typeof fetch, storage: Pick<Storage, "getItem" | "setItem">, key: string, now = Date.now): typeof fetch {
  let blockedUntil = 0;
  const readDeadline = () => {
    try { return Math.max(blockedUntil, Number(storage.getItem(key)) || 0); } catch { return blockedUntil; }
  };
  const trip = (duration = 60_000) => {
    blockedUntil = now() + duration;
    try { storage.setItem(key, String(blockedUntil)); } catch { /* keep the in-tab gate */ }
  };
  return async (input, init) => {
    if (readDeadline() > now()) throw new Error("การเชื่อมต่อ Cloud พักชั่วคราวหลังบริการขัดข้อง ข้อมูลในเครื่องยังอยู่");
    try {
      const response = await fetcher(input, init);
      if (response.status >= 500 || response.status === 429) trip();
      return response;
    } catch (error) {
      if (!(error instanceof Error && error.name === "AbortError")) trip();
      throw error;
    }
  };
}
